<template>
  <div class="app">
    <Nav />
    <div class="app-body">
      <div style="height:100%">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from './footer';
import Nav from './nav';
export default {
  components: {
    Nav,
    Footer
  }
};
</script>
<style scoped>
.app {
  height: 100%;
  overflow: hidden;
}
.app-body {
  /* padding-bottom: 20px; */
  min-width: 1000px;
  width: 90%;
  margin: auto;
  height: calc(100% - 231px);
  background-color: #ffffff;
  /* overflow: auto; */
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>


// WEBPACK FOOTER //
// src/layout/Index.vue